<template >
    <div class="businessList_pages">
      <div class="title">
        <h2>我的业务</h2>
        <div class="search_input">
          <input type="text" v-model="keyword" @input="keywordChange" placeholder="搜索业务单号或客户姓名" clearable />
          <div class="search_icon" @click="search">
            <img src="@img/oldCode/search-icon.png" />
          </div>
        </div>
      </div>
      <div class="apptStatusRow">
        <h3>处理状态</h3>
        <ul>
          <li :class="{on: searchStatus==1}" @click="searchByStatus(1)">全部</li>
          <li :class="{on: searchStatus==2}" @click="searchByStatus(2)">未完成</li>
          <li :class="{on: searchStatus==3}" @click="searchByStatus(3)">已完成</li>
        </ul>
        <div class="btn-download" @click="refreshData">刷新数据</div>
        <div class="btn-download" v-if="limits" @click="unlockAccount">账户解锁</div>
        <div class="btn-download" @click="$refs.downloadFileRef.open()">下载预录入模板</div>
        <div class="btn" @click="openAcct">开户申请</div>
      </div>
  
      <complexTable  ref="complexTableRef" :options="Object.assign({},this.dataGridOptions)"  @on-change="onChange"></complexTable>
 
      <k-dialog
            class="cancellation-style"
            ref="cancellationRef"
            :options="{
              title:'确定要作废该业务吗?',
              center: true,
              width: '30%',
              top: '0',
              destroyOnClose: true,
              isCanClickClose: false,
              showClose: true, 
              onCloseBefore: cancellationCancel, 
              buttons: [
                { text: '取消', handler: cancellationCancel},
                { text: '确定', handler: cancellationOk }
              ]
            }"
          >
          <p style="color:red;text-align:center;font-size:14px;">
          <Icon type="ios-alert" size="14" />业务作废后不可恢复请谨慎操作
        </p>
      </k-dialog>

     <k-dialog
        class="cancellation-style openDialog"
        ref="openDialogRef"
        :options="{
          title:'开户申请',
          center: true,
          width: '37%',
          top: '0',
          destroyOnClose: true,
          isCanClickClose: false,
          showClose: true, 
          buttons: [
            { text: '取消'},
            { text: '确定', handler: handleSubmit }
          ]
        }">
        <div class="modal-body">
          <div class="salesDept"> 
            <el-form :inline="true" label-position="right" ref="orgInfoRef" @submit.native.prevent>
                <k-selector  v-if="salesDepartmentList.length > 0" 
                  id="ORG_CODE" 
                  label='客户所属营业部'
                  placeholder="" 
                  :value.sync="ORG_CODE" 
                  :dicts="salesDepartmentList" 
                  required 
                  :fieldChange="changeOrgCode" />
            </el-form>
          </div>
          <div class="jggtCheck">
            <span>客户是否需落地机构柜台：</span>
            <el-radio-group v-model="IS_JGGT_CHECK">
              <el-radio label="1" class="is-jggt">是</el-radio>
              <el-radio label="0" class="is-jggt">否</el-radio>
            </el-radio-group>
          </div>
          <h4>请选择开户类型</h4>
          <div class="openAcctType_list">
            <ul>
              <li :class="{on: openAcctType == 1}" @click="openAcctType=1">
                <div class="pic">
                  <img :src="require('@img/oldCode/openAccType1-'+(openAcctType==1?'2':'1')+'.png')" />
                </div>
                <span>普通机构</span>
              </li>
              <li :class="{on: openAcctType == 2}" @click="openAcctType=2">
                <div class="pic">
                  <img :src="require('@img/oldCode/openAccType2-'+(openAcctType==2?'2':'1')+'.png')" />
                </div>
                <span>特殊机构</span>
              </li>
              <li :class="{on: openAcctType == 3}" @click="openAcctType=3">
                <div class="pic">
                  <img :src="require('@img/oldCode/openAccType3-'+(openAcctType==3?'2':'1')+'.png')" />
                </div>
                <span>产品开户</span>
              </li>
            </ul>
          </div>
        </div>
      </k-dialog>
      
     <k-dialog
        class="cancellation-style downloadFile"
        ref="downloadFileRef"
        :options="{
          title:'下载预录入模板',
          center: true,
          width: '37%',
          top: '0',
          destroyOnClose: true,
          isCanClickClose: false,
          showClose: true, 
          buttons: [
            { text: '取消'},
            { text: '下载', handler: download }
          ]
        }">
      <div class="modal-body"> 
        <el-form :inline="true" style="padding: .4rem 0 .24rem;" label-position="right"  @submit.native.prevent>
            <k-radio  v-if="salesDepartmentList.length > 0" 
              id="ACC_CLS" 
              label='请选择开户类型模板：'
              placeholder="" 
              FIELD_TYPE="radio"
              :value.sync="ACC_CLS" 
              :dicts="[{DICT_ITEM:'1',DICT_ITEM_NAME:'机构户'},{DICT_ITEM:'3',DICT_ITEM_NAME:'产品户'}]"
              required 
                />
        </el-form>
      </div>
    </k-dialog>
    <k-dialog
        class="cancellation-style changeOp"
        ref="changeOpRef"
        :options="{
          title:'切换面见人',
          center: true,
          width: '37%',
          top: '0',
          destroyOnClose: true,
          isCanClickClose: false,
          showClose: true, 
          onCloseBefore: cancleAcceptor, 
          buttons: [
            { text: '取消', handler: cancleAcceptor},
            { text: '确定', handler: updateAcceptor }
          ]
        }">
        <div class="modal-body">
          <div class="update_main">
            <div class="item">
              <span>当前受理单号：</span>
              <div class="tradeNo">{{B_SNO}}</div>
            </div>
            <div class="item">
              <span>当前面见人工号：</span>
              <div class="tradeNo">{{userInfo.username}}</div>
            </div>
            <div class="item">
              <span>新面见人工号：</span>
              <div class="main">
                <div class="input">
                  <input type="text" placeholder="请输入新面见人的OA工号" v-model="acceptorNo" />
                </div>
                <div class="tip"><img src="@img/oldCode/tip.png" />面见人：指需要去客户现场办理开户业务的员工</div>
              </div>
            </div>
          </div>
        </div>
    </k-dialog>
    <k-dialog
        class="cancellation-style seeSteps"
        ref="seeStepsRef"
        v-if="seeStepsModa"
        :options="{
          title:'查看步骤详情',
          center: true,
          width: '56%',
          top: '0',
          destroyOnClose: true,
          isCanClickClose: false,
          showClose: true, 
          onCloseBefore: closeSeeModal, 
          buttons: [
          ]
        }">

    <!-- <div id="steps" class="openModal" v-show="seeStepsModa">
        <div class="modal-header">
          <h3 style="font-weight:bold;">查看步骤详情</h3>
          <div class="close" @click="seeStepsModa = false">×</div>
        </div> -->
        <div class="modal-body" >
          <div class="update_main"> 
             <complexTable  ref="seeStepsComplexTableRef" :options="Object.assign({},this.seetDataGridOptions)"></complexTable> 
            </div>
        </div>
      <!-- </div> -->
    </k-dialog>
    <!-- 转移一站通弹框 -->
    <k-dialog
      class="cancellation-style moveYzt"
      ref="moveYztRef"
      :options="{
        title:'指定临柜受理人',
        center: true,
        width: '36%',
        top: '0',
        destroyOnClose: true,
        isCanClickClose: false,
        showClose: true, 
        buttons: [
        { text: '取消'},
        { text: '确定', handler: yesMove }
        ]
      }">
      <!-- <div class="openModal" v-show="moveModel">
        <div class="modal-header">
          <h3>指定临柜受理人</h3>
          <div class="close" @click="moveModel = false">×</div>
        </div> -->
        <div class="modal-body">
          <div class="update_main">
            <div class="item">
              <span>临柜受理人工号：</span>
              <div class="main">
                <div class="input">
                  <input type="text" placeholder="请输入指定的临柜业务办理人员OA工号" v-model="yztOA" />
                </div>
                <div class="tip"><img class="warnImg" src="@img/oldCode/tip.png" />受理人：指一站通临柜受理业务的人员&nbsp;&nbsp;<br>
                  <br>（请确保指定受理人有开户权限）
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="modal-footer">
          <div class="btns">
            <div class="btn cancel" @click="noMove">
              取消
            </div>
            <div class="btn confirm" @click="yesMove">
              确定
            </div>
          </div>
        </div>
      </div> -->
    </k-dialog>
      <!-- 转移VTM弹框 -->
      <k-dialog
        class="cancellation-style moveVtm"
        ref="moveVtmRef"
        :options="{
          title:'指定受理网点（机构代码）',
          center: true,
          width: '36%',
          top: '0',
          destroyOnClose: true,
          isCanClickClose: false,
          showClose: true, 
          buttons: [
          { text: '取消'},
          { text: '确定', handler: yesMoveVTM }
          ]
        }">
      <!-- <div class="openModal" v-show="moveModelVTM">
        <div class="modal-header">
          <h3>指定受理网点（机构代码）</h3>
          <div class="close" @click="moveModelVTM = false">×</div>
        </div> -->
        <div class="modal-body">
          <div class="update_main">
            <div class="item"> 
              <div class="main">   
                <el-form :inline="true" label-position="right" ref="orgVtmInfoRef" @submit.native.prevent>
                    <k-selector  v-if="salesDepartmentList.length > 0" 
                      id="ORG_CODE" 
                      label='机构代码'
                      placeholder="" 
                      :value.sync="moverVTMOrgCode" 
                      :dicts="salesDepartmentList"
                      required 
                      :fieldChange="changeOrgCode" />
                </el-form>
              </div> 
            </div>
          </div>
        </div>
      </k-dialog>
        <!-- <div class="modal-footer">
          <div class="btns">
            <div class="btn cancel" @click="noMoveVTM">
              取消
            </div>
            <div class="btn confirm" @click="yesMoveVTM">
              确定
            </div>
          </div>
        </div>
      </div>-->
  </div> 
</template>

<script>
import VPage from "@old/components/common/page";
// import temp from "@/components/print/04x";
import util from "@old/commonTools/util";
import dict from "@/tools/dict";
import complexTable from "@/components/common/complexTable.vue";
import kDialog from "@/components/common/dialog.vue";
import kSelector from "@/components/baseUI/kSelector";
import kRadio from "@/components/baseUI/kRadio";
import { mapMutations } from "vuex";
import oppService from "../../service/opp-service";

export default {
  components: {
    VPage,
    complexTable,
    kDialog,
    kSelector,
    kRadio
    // temp
  },
  data () {
    return {
      yztOA: "", //一站通oa
      yztOAApptSn: "",
      yztBsno: "",
      auditorName: "", // 审核人名字
      auditorTel: "", // 审核人电话
      auditorTitle: [
        {
          title: "姓名",
          key: "USER_NAME",
          // width: 150
        },
        {
          title: "联系电话",
          key: "MOBILE_TEL",
          // width: 150
        },
        {
          title: "流程节点",
          key: "NODE_NAME"
        },
        {
          title: "处理时间",
          key: "OPER_TIME",
          // width: 200
        },
        {
          title: "处理结果",
          key: "PROC_STATUS"
        }
      ],
      moveModel: false,
      moveBusiCode: "",
      auditorList: [], // 审核人员信息
      seeStepsModa: false, //查看步骤弹窗
      buttimer: true, 
      cancellationData: {},
      limits: false, // 受理数据修改权限
      acceptorNo: "", //面见人工号
      apptSn: "", //指定面见人选择的流水号
      B_SNO: "", //第三方流水号
      ACC_CLS: "", //1是机构户，3是产品户，预录入模板
      // showModal: false, //显示开户申请弹窗
      // showModal2: false, //显示预录入模板下载弹窗
      // showModal3: false, //显示指定面见人弹窗
      openAcctType: 1, //开户类型，默认普通机构
      ORG_CODE: "", //营业部
      // salesDeptName: "", //营业部名称
      salesDepartmentList: [], //营业部列表
      OPENTMPL_INFO: null, //客户模板
      NEW_CUST_CODE: "", //客户代码
      keyword: "", //搜索关键字13914324032300001 13914324041700002
      APPT_SN: "", //流水号
      custName: "", //客户姓名
      searchStatus: 1, //搜索状态
      offset: 0,
      pageSize: 10,
      dataList: [],
      totalCount: 0,
      accType: ["普通机构", "特殊机构", "产品开户"], //机构类型
      APPT_STATUS_DICT: [
        {
          type: 1,
          stateName: "办理中"
        },
        {
          type: 2,
          stateName: "预审中"
        },
        {
          type: 3,
          stateName: "预审驳回"
        },
        {
          type: 4,
          stateName: "预审通过"
        },
        {
          type: 5,
          stateName: "风险揭示中"
        },
        {
          type: 6,
          stateName: "风险揭示完成"
        },
        {
          type: 7,
          stateName: "风险揭示驳回"
        },
        {
          type: 8,
          stateName: "视频见证/风险揭示中"
        },
        {
          type: 9,
          stateName: "视频见证/风险揭示完成"
        },
        {
          type: 10,
          stateName: "视频见证/风险揭示驳回"
        },
        {
          type: 11,
          stateName: "审核中"
        },
        {
          type: 12,
          stateName: "审核驳回"
        },
        {
          type: 13,
          stateName: "办理完成"
        },
        {
          type: 14,
          stateName: "已作废"
        },
        {
          type: 15,
          stateName: "挂起"
        },
        {
          type: 16,
          stateName: "异常处理中"
        },
        {
          type: 17,
          stateName: "已转移到VTM"
        },
        {
          type: 18,
          stateName: "已转移到一站通"
        },
        {
          type: 19,
          stateName: "已转移到新平台"
        },
      ],
      // auditorInfoShow: false, // 审核人信息
      moveModelVTM: false,
      moverVTMOrgCode: "", //转移VTM 机构代码
      vtmApptSn: "",
      inputCustInfo: {
        CUST_FNAME: "",
        ID_TYPE: "",
        ID_CODE: ""
      },
      ID_TYPE_ARR: [],
      IS_JGGT_CHECK: ""
    };
  },
  computed: {
    userInfo () {
      return this.$storage.getJsonSession(this.$definecfg.USER_INFO);
    },
    editAuth (){
      return this.$store.state.permission.editAuth;
    },
    checkAuth (){
      return this.$store.state.permission.checkAuth;
    },
    witnessAuth (){
      return this.$store.state.permission.witnessAuth;
    },
    dataGridOptions () {
      var that = this;
      return {
        headerCellStyle:{"background":"#efefef","height":" 0.55rem","font-size":"16PX","color":"#343434","font-weight":"500"},
        rowStyle:{"height":" 0.55rem","font-size":"14PX","color":"#343434","font-weight":"500"},
        columns: [
          { title: "处理状态", field: "APPT_STATUS_TEXT", width: "9%"},
          // { title: "业务名称", field: "BUSI_NAME", width: 160},
          { title: "受理单号", field: "B_SNO", width: "12.8%"},
          { title: "开户类型", field: "CUST_TYPE_TEXT", width: "8%"},
          { title: "客户姓名", field: "CUST_FNAME", width: "24%"},
          { title: "证件类型", field: "ID_TYPE_TEXT", width: "10.4%"},
          { title: "证件号码", field: "ID_CODE", width: "14.4%"},
          { title: "操作时间", field: "OPERATE_TIME", width: "12%"},  
          { title: "操作", field: "OP", width: "10.4%"}
        ],
        isBackGround: true,
        pageLayout: "total, prev, pager, next, jumper",
        width: "100%" 
      };
    },
    seetDataGridOptions (){
      return { 
        headerCellStyle:{"background":"#efefef","height":"38px","font-size":"16PX","color":"#343434","font-weight":"500"},
        rowStyle:{"height":"38px","font-size":"14PX","color":"#343434","font-weight":"500"},
        columns: [
          { title: "姓名", field: "USER_NAME" , width: "14%"},
          { title: "联系电话", field: "MOBILE_TEL", width: "14%"},
          { title: "流程节点", field: "NODE_NAME", width: "16.3%"},
          { title: "处理时间", field: "OPER_TIME", width: "19.2%"},
          { title: "处理结果", field: "PROC_STATUS", width: "16.3%"},
          { title: "备注", field: "REMARK", width: "19.2%"},
        ],
        isBackGround: false,
        isShowFooter: false,
        pageLayout: "total",
        width: "100%",
      };
    }
  },
  async created () {
    this.$blMethod.homeClean();
    if (!this.userInfo) {
      this.alert("登录数据失效，请重新登录！"); 
      return;
    } 
    this.checkUserName();
    // this.getDataList();

    this.UPDATE_APPT_STATUS(""); 
    this.UPDATE_APPT_SN("");
    this.UPDATE_OPEN_ACCTTYPE("");
    this.UPDATE_B_SNO(""); 
    this.getBusinessHall(); 
    sessionStorage.removeItem("PRINT_TEST"); 
  },
  mounted (){
    let that =this; 
    that.$nextTick(()=>{
      this.getDataList();  
    }); 
  },
  beforeDestroy () {
  },
  methods: {
    // 显示审核人信息
    searchAuditorInfo (name) {
      // console.log(1);
      // this.auditorInfoShow = true;
    },
    // 权限查询
    async checkUserName () {
      let that = this;
      that.limits = false;
      // 跟业务确认，这个按钮先屏蔽，不做展示
      // if(!_.isEmpty(that.userInfo) && that.userInfo.username){
      //   await that.$syscfg.K_Request("F0000000", {
      //     SERVICE_CODE: "QSA160021",
      //     USERNAME:that.userInfo.username,
      //   }, true).then(res => {
      //     if(res && res.Code == "0" && res.Data && res.Data[0]){
      //       that.limits = true;
      //     }
      //   }).catch(err=>{
      //     that.limits = false;
      //   }); 
      // }
    },
    // 进入数据修改页面
    unlockAccount () {
      this.$router.push({ name: "unlockAccount" });
    },
    //更新流水状态， 14，作废
    async cancelBizAciton (APPT_SN, APPT_STATUS, bsno) {
      let data = {
        APPT_STATUS: APPT_STATUS,
        APPT_SN: APPT_SN
      };
      let res0 = await oppService.updateApptStatus(APPT_SN, APPT_STATUS, bsno);
      if(res0.Code === "0"){
        this.$store.commit(this.$types.UPDATE_APPT_STATUS, "");
        if(!!bsno){
          let res1 = await oppService.cancelBiz(bsno);
          if(res1.Code === "0"){
            return true;
          }else{
            return false;
          }
        }else{
          return true;
        }
      }else{
        return false;
      }
    },
    ...mapMutations(["UPDATE_APPT_STATUS", "UPDATE_OPEN_ACCTTYPE", "UPDATE_B_SNO",
      "CHANGE_CUST_CODE","UPDATE_APPT_SN"]),
    route (url) {
      this.$router.push(url);
    },
    //搜索
    search () {
      this.keywordChange();
    },
    // 刷新数据
    refreshData () {
      this.getDataList(this.keyword);
    },
    //状态搜索
    searchByStatus (APPT_STATUS) {
      this.searchStatus = APPT_STATUS;
      this.search();
    },
    //关键字搜索
    keywordChange () {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        let code = "";
        this.keyword = this.keyword.replace(/(^\s*)|(\s*$)/g, "");
        if (util.isNumber(this.keyword) && this.keyword.indexOf(".") === -1 && this.keyword.length === 17) {
          code = this.keyword;
          this.custName = "";
        } else {
          code = "";
          this.custName = this.keyword;
        }
        code = code.replace(/(^\s*)|(\s*$)/g, "");
        this.offset = 0;
        this.getDataList(code);
      }, 500);
    },
    getDataList (code) {
      let that =this;
      that.$store.commit(that.$types.UPDATE_LOADING, "正在查询");
      let params = {
        page: that.offset + 1,
        pagecount: that.pageSize,
        B_SNO: code || "",
        PRESENT_OR_PAST:"2",//默认查归档库
        OP_CODE: that.userInfo.OP_CODE
      };
      params["searchStatus"] = that.searchStatus;
      if (that.custName) {
        params["CUST_FNAME"] = that.custName;
      }
      that.$syscfg.K_Request("F0000013", params).then(res => {
        if (res.Code == 0) {
          let data = res.Data[0] || {};
          return dict.transformDict(data.dataList, ["ID_TYPE"]).then(res => {
            _.each(res, item => {
              if (item.APPT_STATUS) {
                //去除空格
                item.APPT_STATUS = item.APPT_STATUS.replace(" ","");
              }
              let busiDict = {
                "QS138":"非现场机构开户",
                "QS420":"非现场机构开户（新）",
                "QS139":"非现场产品开户",
                "QS421":"非现场产品开户（新）",
              };
              item.BUSI_NAME = busiDict[item.APPT_BUSI_CODE];
              item.CUST_TYPE_TEXT  = that.accType[item.OPEN_ACCT_TYPE-1];

              var apptStatusObj = _.find(that.APPT_STATUS_DICT,v=>v.type == item.APPT_STATUS);

              item.APPT_STATUS_TEXT = apptStatusObj && apptStatusObj.stateName ||"";

            });
            that.dataList = res;
            that.totalCount = parseInt(data.totalCount);

            let resultList = that.getBusiActionList(that.dataList);
            that.$nextTick(()=>{
              that.$refs.complexTableRef.loadData(resultList,that.totalCount);
            });

          });
        } else {
          that.alert(res.Msg || "获取数据失败！");
        }
      }).finally(()=>{
        that.$store.commit(that.$types.UPDATE_LOADING, false);
      });
    },
    // 获取业务可操作列表
    getBusiActionList (list){
      let that = this;
      list.map((row)=>{
        let tempList1 = [],tempList2 = [];
        var apptStatus = row.APPT_STATUS;

        if(apptStatus == "1"){
          tempList1.push({
            text: "续办",
            flag:"0",
            btnHandler () {
              that.edit(row);
            }
          });
        }

        if(_.includes(["2","11","13","14","15","18","16","17"],apptStatus)){
          tempList1.push({
            text: "详情",
            flag:"0",
            btnHandler () {
              that.toDetails(row);
            }
          });
        }

        if(_.includes(["4","5","6","8","9"],apptStatus)){
          tempList1.push({
            text: "续办",
            flag:"0",
            btnHandler () {
              that.toDetails(row);
            }
          });
        }

          
        if(_.includes(["3","7","10","12"],apptStatus)){
          tempList1.push({
            text: "修改",
            flag:"0",
            btnHandler () {
              that.edit(row);
            }
          });
        }

          

        if(apptStatus>3 && !_.includes(["11","13","14","15","16","17","18"],apptStatus) || _.includes(["1","2","11","16"],apptStatus)  || apptStatus >=4 && apptStatus <=16){

          if(apptStatus == "12" || apptStatus>=4 && apptStatus <=10){
            tempList2.push({
              text: "转移一站通办理",
              flag:"1",
              btnHandler () {
                that.movetoYZT(row.APPT_SN,row.B_SNO, row.APPT_BUSI_CODE);
              }
            });
            tempList2.push({
              text: "转移VTM办理",
              btnHandler () {
                that.movetoVTM(row.APPT_SN,row.B_SNO, row.APPT_BUSI_CODE);
              }
            });
          }

          // if(_.includes(["2","11","16"],apptStatus)){
          if(row.B_SNO){
            tempList1.push({
              text: "查看步骤",
              flag:"1",
              btnHandler () {
                that.seeSteps(row.B_SNO);
              }
            }); 
          }
          
          // }
 
          if(apptStatus > 3 && !_.includes(["11","13","14","15","16","17","18"],apptStatus)){
            tempList2.push({
              text: "切换面见人",
              flag:"1",
              btnHandler () {
                that.appoint(row.APPT_SN,row.B_SNO);
              }
            }); 
          }

          if(apptStatus == "1"){
            tempList2.push({
              text: "作废",
              flag:"1",
              btnHandler () {
                that.cancellation(row.APPT_SN,row);
              }
            }); 
          }
        } 

        return Object.assign(row, {
          visible: false,
          actionList1: tempList1,
          actionList2: tempList2
        });
      });

      return list;
    },
    onChange (page) {
      this.offset = page - 1;
      this.getDataList();
    },
    //获取营业厅列表
    async getBusinessHall () {
      let res = await this.$syscfg.K_Request("F0000011");
      if (res.Code == 0) {
        let orgData = _.cloneDeep(res.Data);
        let tempArr = _.filter(orgData,v=>{
          v.DICT_ITEM = v.ORG_CODE;
          v.DICT_ITEM_NAME = v.ORG_FULL_NAME;
          return  !_.includes(["999","222"],v.ORG_CODE);
        });

        this.salesDepartmentList =tempArr; 
      }
      return res;
    },
    //获取客户代码
    async getCustCode (code) {
      let res = await this.$syscfg.K_Request("F0000020", {
        ORG_CODE: this.ORG_CODE
      });
      if (res.Code == 0) {
        let code = res.data.data[0].USER_CODE;
        this.CHANGE_CUST_CODE(code);
        this.NEW_CUST_CODE = code;
      }
      return res;
    },
    //创建见证流水
    addData () {
      if(!this.openAcctType){
        this.alert("开户申请类型不能为空");
        return;
      }
      return oppService.saveOppApptData({
        OPEN_ACCT_TYPE: this.openAcctType,
        OP_CODE: this.userInfo.OP_CODE,
        CUST_ORG_CODE: this.ORG_CODE,
        BUSI_CODE:this.openAcctType == "2" ? "QS421" : "QS420"
      }, "1");
    },
    //获取客户模板
    getOpenAccountTemplate () {
      let data = {
        ORG_CODE: this.ORG_CODE,
        USER_TYPE: this.openAcctType == "3" ? "2" : "1"
      };
      return this.$syscfg.K_Request("F0000019", data);
    },
    async handleSubmit () {
      // 营业机构不能为空
      if (!this.ORG_CODE) {
        this.alert("客户所属营业部不能为空!");
        return false;
      }
      if (!this.IS_JGGT_CHECK) {
        this.alert("请选择客户是否需落地机构柜台！");
        return false;
      }
      if(this.IS_JGGT_CHECK == "1") {
        let linkBusiName = this.openAcctType == "3" ? "【产品开户（新一代）】" : "【开户业务（新一代）】";
        this.alert("请通过聚安一站通系统的" + linkBusiName + "菜单发起开户申请");
        return false;
      }
      this.$store.commit(this.$types.UPDATE_LOADING, true);
      let template = await this.getOpenAccountTemplate();
      if (template.Code != 0) {
        this.alert(template.Msg || "请求错误！");
        return false;
      } else {
        let data = template.Data[0];
        if (!data.CUST_CLS) {
          this.alert("客户模板中客户分类字段缺失！");
          return false;
        }
        if (!data.CHANNELS) {
          this.alert("客户模板中操作渠道字段缺失！");
          return false;
        }
        if (!data.CUACCT_CLS) {
          this.alert("客户模板中资金类别字段缺失！");
          return false;
        }
        if (!data.CUACCT_LVL) {
          this.alert("客户模板中资产级别字段缺失！");
          return false;
        }
        if (!data.CUACCT_GRP) {
          this.alert("客户模板中资产组别字段缺失！");
          return false;
        }
        if (!data.CUACCT_ATTR) {
          this.alert("客户模板中资产属性字段缺失！");
          return false;
        }
      }
      this.updateBusiCode();

      this.OPENTMPL_INFO = template.Data[0];
      this.inputCustInfo.USER_TYPE = this.userType || "1"; 
      this.inputCustInfo.INT_ORG = this.ORG_CODE;
      this.$storage.setSession(this.$definecfg.F_CUST_ORG_CODE, this.ORG_CODE);
      this.$storage.setSession(
        this.$definecfg.CUSTOMER_INFO,
        this.inputCustInfo
      );

      this.UPDATE_OPEN_ACCTTYPE(this.openAcctType);
      let res = await this.addData();
      if (res.Code == 0) {
        window.localStorage.removeItem("uploadFlag");
        window.localStorage.removeItem("isSaveInfo");
        this.gotoNext();
      } else {
        this.alert(res.data.msg);
        return false;
      }
    },
    updateBusiCode (){
      this.userType = "1";
      this.busiCode = "QS420";
      if (this.openAcctType == "3") {
        this.userType = "2";
        this.busiCode = "QS421";
      }
      this.$store.commit(this.$types.UPDATE_USER_TYPE, this.userType);
      this.$store.commit(this.$types.UPDATE_BUSI_CODE, this.busiCode);
    },
    gotoNext () {  
      if (this.inputCustInfo.USER_TYPE !== "0") {
        this.$router.replace({
          name: "customerCheck",
          params: { busiCode: this.busiCode, userType: this.userType }
        });
        return;
      }
    },
    //流水单号续办、修改操作
    edit (item) {
      if(!this.checkReadAuth()){
        return false;
      }
      if (item.APPT_STATUS < 4) {
        window.localStorage.removeItem("uploadFlag");
        window.localStorage.removeItem("isSaveInfo");
      }
      if(item.APPT_BUSI_CODE=="QS138" || item.APPT_BUSI_CODE === "QS139"){
        this.alert("正在开发中");
        return;
      }
      consoleLog(`续办一站通流水号${item.B_SNO}和非现场流水号${item.APPT_SN}`);
      this.updateLocalData(item);
      this.gotoNext();
    },
    //详情
    async toDetails (item) {
      if(!this.editAuth && !this.witnessAuth && !this.checkAuth){
        this.alert("您无权操作，请先申请权限");
        return false;
      }
      if (item.APPT_STATUS < 4) {
        window.localStorage.removeItem("uploadFlag");
        window.localStorage.removeItem("isSaveInfo");
      }
      if(item.APPT_BUSI_CODE=="QS138" || item.APPT_BUSI_CODE === "QS139"){
        this.alert("正在开发中");
        return;
      }
      consoleLog(`详情一站通流水号${item.B_SNO}和非现场流水号${item.APPT_SN}`);
      this.updateLocalData(item);   
      this.gotoNext();
    },
    updateLocalData (item){
      this.UPDATE_B_SNO(item.B_SNO || "");
      this.UPDATE_APPT_STATUS(item.APPT_STATUS);
      this.UPDATE_APPT_SN(item.APPT_SN);
      this.UPDATE_OPEN_ACCTTYPE(item.OPEN_ACCT_TYPE);
      if(this.$syscfg.isOrgOpenAcctBiz(item.APPT_BUSI_CODE)){
        this.userType = "1";
      }else if(this.$syscfg.isProOpenAcctBiz(item.APPT_BUSI_CODE)){
        this.userType = "2";
      }
      this.$storage.setSession(this.$definecfg.CUSTOMER_INFO,{
        INT_ORG: item.CUST_ORG_CODE,
        CUST_NAME: item.CUST_NAME,
        CUST_FNAME: item.CUST_FNAME,
        ID_TYPE: item.ID_TYPE,
        ID_CODE: item.ID_CODE,
        USER_TYPE: this.userType,
        CUST_CODE: item.CUST_CODE,
      });
      this.$store.commit(this.$types.UPDATE_USER_TYPE, this.userType);
      this.$store.commit(this.$types.UPDATE_BUSI_CODE, item.APPT_BUSI_CODE);
      this.$storage.setSession(this.$definecfg.F_CUST_ORG_CODE, item.CUST_ORG_CODE);
      this.busiCode = item.APPT_BUSI_CODE;
    },
    //选择营业部
    changeOrgCode (value) {
      // let list = this.salesDepartmentList;
      // for (let i = 0, l = list.length; i < l; i++) {
      //   if (this.ORG_CODE === list[i].ORG_CODE) {
      //     this.salesDeptName = list[i].ORG_FULL_NAME;
      //   }
      // }
    },
    //运营岗+见证岗才能修改资料
    checkEditAuth (){
      if(!this.editAuth){
        this.alert("您无权操作，请先进行权限申请。");
        return false;
      }
      return true;
    },
    //只有见证岗时，无法修改资料，只能查看见证节点
    checkReadAuth (){
      if(!this.witnessAuth){
        this.alert("您无权操作，请先进行权限申请。");
        return false;
      }
      return true;
    },
    //开户申请
    async openAcct () {
      if(!this.checkEditAuth()){
        return;
      }
      //OPPCP-34256 清空客户所属机构默认值
      // this.ORG_CODE = this.userInfo.ORG_CODE;
      if (this.salesDepartmentList && this.salesDepartmentList.length > 0) {
        this.$refs.openDialogRef.open();
      } else {
        let res = await this.getBusinessHall();
        if (res.Code == "0") {
          this.$refs.openDialogRef.open();
        } else {
          this.alert(res.Msg || "获取营业部列表失败，请重试！");
        }
      }
    },
    //下载预录入模板
    async download () {
      if (!this.ACC_CLS) {
        this.alert("请选择需要下载的开户类型模板！");
        return false;
      }
      let ACC_CLS = this.ACC_CLS == 3 ? 1 : 0;
      let url = "", name = "";
      if (this.ACC_CLS == 3) {
        url = "../../static/download/product.7z";
        name = "产品户.7z";
      } else {
        url = "../../static/download/cust.7z";
        name = "机构户.7z";
      }
      let a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("download", name);
      a.click();
      a = null;
      //		    	let res = await this.$api.get(downloadTemplate+ACC_CLS);
      //		    	if(res.data.errcode && res.data.errcode != 0) {
      //		    		this.alert(res.data.msg || '下载模板失败！');
      //		    	}else {
      //		    		let a = document.createElement('a');
      //		    		a.setAttribute('href', res);
      //		    		a.setAttribute('download', ACC_CLS == 0?'机构户预录入模板':'产品户预录入模板');
      //		    		a.click();
      //		    		a = null;
      //		    	}
    },
    //打开指定面见人弹窗
    appoint (apptSn, B_SNO) {
      if(!this.checkReadAuth()){
        return false;
      }
      // console.log('$store.state.login',this.$store.state.login)
      this.apptSn = apptSn;
      this.B_SNO = B_SNO;
      this.$refs.changeOpRef.open();
    },
    // 查看步骤弹窗
    async seeSteps (B_SNO) {
      this.seeStepsModa = true;
      let res = await this.$syscfg.K_Request("P001001115", {
        B_SNO
      });
      this.$refs.seeStepsRef.open();
      if (res.Code == 0) {
        if (!res.Data.length) {
          alert("当前暂无人受理，请稍后查询");
          return;
        }
        this.auditorList = res.Data;
        this.auditorList.forEach((item, index) => {
          //待自动处理节点替换成自动处理
          if (item.NODE_KEY && item.NODE_KEY.startsWith("completeTask") && item.NODE_NAME != "业务完成") {
            item.USER_NAME = "自动处理";
            item.NODE_NAME = "自动处理";
            item.MOBILE_TEL = "";
          }
          this.auditorList[index].PROC_STATUS = this.changeResult(item.VAR_VALUE, item);
        });
        this.auditorName = res.Data[res.Data.length - 1].USER_NAME;
        this.auditorTel = res.Data[res.Data.length - 1].MOBILE_TEL;
        let that = this;
        setTimeout(()=>{
          this.$nextTick(()=>{
            console.log(" that.$refs.seeStepsComplexTableRef",  that.$refs.seeStepsComplexTableRef);
            that.$refs.seeStepsComplexTableRef.loadData(that.auditorList, that.auditorList.length);
          });        
        }, 100);
       
      } else {
        if (res.Msg) {
          alert(res.Msg);
        } else {
          alert("查询接口失败");
        }
      }
    },
    changeResult (val, row) {
      var text = "通过";
      if (row.NODE_KEY != "bizAcceptTask" && row.NODE_KEY != "creditOpen") {
        switch (val) {
          case "0":
            text = (row.NODE_KEY == "repAppvTask") ? "影像驳回" : "驳回";
            //待自动处理驳回替换成处理失败
            if (row.NODE_KEY && row.NODE_KEY.startsWith("completeTask")) {
              text = "处理失败";
            }
            break;
          case "1":
            text = "通过";
            break;
          case "2":
            text = "业务驳回";
            break;
          case "3":
            text = "挂起";
            break;
          case "4":
            text = "作废";
            break;
          case "5":
            text = "驳回";
            break;
          case "6":
            text = "驳回";
            break;
          // case  "7":  //外币取出小额取款时用
          //         text = '通过';
          //         break;
          // case  "8":
          //         text = '放弃审批';
          //         break;
          // case  "19":
          //     text = '驳回';  //外围用的驳回标识（旧标识，兼容历史业务展示）
          // case  "12":
          //     text = '驳回';
          // case  "53":
          //     text = '驳回';  //外围用的驳回标识
          //     break;
          //  // OA审批结果转义
          // case  "A":  
          // 	text = '提交文档'; 
          // 	break;
          // case  "B":  
          // 	text = '转办'; 
          // 	break;
          // case  "C":  
          // 	text = '废弃'; 
          // 	break;
          // case  "D":  
          // 	text = '沟通'; 
          // 	break;
          default:
            text = "处理中";
        }
      }
      return text;
    },
    // 节流
    debounce () {
      var that = this;
      return (function () {
        if (that.buttimer) {
          that.start();
          that.buttimer = false;
          setTimeout(() => {
            if (that.buttimer) return;
            that.buttimer = true;
          }, 2000);
        }
      })();
    },
    async start () {
      let data = {
        "APPT_SN": this.apptSn,
        B_SNO: this.B_SNO,
        "acceptorNo": this.acceptorNo
      };
      this.$store.commit(this.$types.UPDATE_LOADING, "操作中");
      let res = await this.$syscfg.K_Request("F0000026", data);
      this.$store.commit(this.$types.UPDATE_LOADING, false);
      if (res.Code == 0) {
        this.$refs.changeOpRef.close();
        this.getDataList();
        this.acceptorNo = "";
      } else {
        this.alert(res.data.msg || "操作失败！");
      }
    },
    //指定面见人
    updateAcceptor () {
      if (!this.acceptorNo) {
        this.alert("请输入指定面见人工号！");
        return false;
      }
      if (!this.apptSn) {
        this.alert("流水号有误！");
        return false;
      }
      if (!util.isNumLetter(this.acceptorNo)) {
        this.alert("面见人工号格式有误！");
        return false;
      }
      // 不允许切换面见人给自己
      if (this.userInfo && this.userInfo.username && this.userInfo.username === this.acceptorNo.trim()) {
        this.alert("切换面见人前后为同一人，无需操作。");
        return false;
      } else if (!this.userInfo) {
        this.alert("找不到操作人信息， 请重新登录！");
        return false;
      }
      this.debounce();
    },
    //取消
    cancleAcceptor () {
      this.showModal3 = false;
      this.$refs.changeOpRef.close();
      this.acceptorNo = "";
    },
    async cancellationOk () {
      let data = this.cancellationData;
      this.$store.commit(this.$types.UPDATE_LOADING, "操作中");
      let flag = await this.cancelBizAciton(data.APPT_SN, "14", data.B_SNO);
      if (flag) {
        this.alert("作废成功");
        this.$refs.complexTableRef.page.currentPage=0;
        this.$store.commit(this.$types.UPDATE_LOADING, false);
      } else {
        this.$store.commit(this.$types.UPDATE_LOADING, false);
        this.confirm({
          messageText: "作废失败",
          cancelButtonText: "取消",
          confirmButtonText: "重试",
          confirmedAction: () => {
            this.cancellationOk();
          },
        });
      }
  
      this.$refs.cancellationRef.close();
    },
    cancellationCancel () {
      this.$refs.cancellationRef.close();
    },
    closeSeeModal (){
      this.seeStepsModa = false;
    },
    cancellation (APPT_SN, item) {
      if(!this.checkEditAuth()){
        return;
      }
      this.cancellationData =  {
        APPT_SN: APPT_SN,
        APPT_STATUS: "14",
        B_SNO: item.B_SNO, //一站通流水
      };
 
      this.$refs.cancellationRef.open();
    },
    movetoYZT (APPT_SN, B_SNO, BUSI_CODE) {
      if(!this.checkEditAuth()){
        return;
      }
      this.yztOA = "";
      this.yztOAApptSn = APPT_SN;
      this.yztBsno = B_SNO;
      // this.moveModel = true;
      this.$refs.moveYztRef.open();
      this.moveBusiCode = BUSI_CODE;
    },
    movetoVTM (APPT_SN, B_SNO, BUSI_CODE) {
      if(!this.checkEditAuth()){
        return;
      }
      this.moverVTMOrgCode = "";
      this.vtmApptSn = APPT_SN;
      this.yztBsno = B_SNO;
      // this.moveModelVTM = true;
      this.$refs.moveVtmRef.open();
      this.moveBusiCode = BUSI_CODE;
    },
    yesMove () {
      if (!this.yztOA) {
        this.alert("请输入一站通受理人OA工号！");
        return false;
      }
      // if(!this.tradeNo) {
      // 	this.alert('流水号有误！');
      // 	return ;
      // }
      if (!util.isNumLetter(this.yztOA)) {
        this.alert("面见人工号格式有误！");
        return false;
      }
      if (this.userInfo && this.userInfo.username && this.userInfo.username === this.acceptorNo.trim()) {
        this.alert("切换面见人前后为同一人，无需操作。");
        return false;
      } else if (!this.userInfo) {
        this.alert("找不到操作人信息， 请重新登录！");
        return false;
      }
      const that = this;
      this.confirm({
        messageText:"该业务流水转至一站通办理后，该笔非现场业务流水将作废，请确认是否继续！",
        cancelButtonText: "否",
        confirmButtonText: "是",
        confirmedAction: async () => {
          that.$store.commit(that.$types.UPDATE_LOADING, true);
          let busiDict = {
            "QS420":"Z0035",
            "QS421":"Z0438",
          };
          let data = {
            "BUSI_CODE": busiDict[that.moveBusiCode],
            "APPT_SN": that.yztOAApptSn,
            "OP_CODE": that.yztOA,
            "moveFlag": "yzt"
          };
          let res = await that.$syscfg.K_Request("F0000086", data);
          if (res.Code == 0) {
            //转vtm之后更新预约流水状态为18-转一站通
            let res1 = await oppService.updateApptStatus(that.yztOAApptSn, "18", this.yztBsno);
            //作废旧的一站通流水
            let res2 = await oppService.cancelBiz2(this.yztBsno, "智能见证业务转一站通业务");
            if(res1.Code == "0"&& res2.Code == "0"){
              that.getDataList();
              that.alert({
                messageText: "创建一站通流水，操作成功",
                confirmButtonText: "确定",
                confirmedAction: function () {
                  // that.moveModel = false;
                  // this.$refs.moveYztRef.close();
                }
              });
            }
            that.moverVTMOrgCode = "";
          } else {
            that.alert(res.Msg || "操作失败！");
            that.$store.commit(this.$types.UPDATE_LOADING, false);
          }
        },
        canceledAction:  () => {
        }
      });
    },
    // noMove () {
    //   // this.moveModel = false;
    // },
    //OPPCP-15760 【非现场机构/产品开户】-业务流程转VTM
    yesMoveVTM () {
      if (!this.moverVTMOrgCode) {
        this.alert("请选择机构代码！");
        return false;
      }
      const that = this;
      this.confirm({
        messageText:"该业务流水转至VTM办理后，该笔非现场业务流水将作废，请确认是否继续；&若表单需在VTM办理时使用，请重新打印。",
        cancelButtonText: "否",
        confirmButtonText: "是",
        confirmedAction: async () => {
          that.$store.commit(this.$types.UPDATE_LOADING, true);
          let busiDict = {
            "QS420":"V0036",
            "QS421":"V0037",
          };
          let data = {
            "BUSI_CODE": busiDict[that.moveBusiCode],
            "APPT_SN": that.vtmApptSn,
            "ORG_CODE": that.moverVTMOrgCode,
            "moveFlag": "vtm"
          };
          let res = await this.$syscfg.K_Request("F0000086", data);
          if (res.Code == 0) {
            //转vtm之后更新预约流水状态为17-转vtm
            let res1 = await oppService.updateApptStatus(that.vtmApptSn, "17", this.yztBsno);
            //作废旧的一站通流水
            let res2 = await oppService.cancelBiz2(this.yztBsno, "智能见证业务转VTM业务");
            if(res1.Code == "0"&& res2.Code == "0"){
              that.getDataList();
              that.alert({
                messageText: "创建VTM流水，操作成功",
                confirmButtonText: "确定",
                confirmedAction: function () {
                  that.moveModelVTM = false;
                  // this.$refs.moveVtmRef.close();
                }
              });
            }
            that.moverVTMOrgCode = "";
          } else {
            that.alert(res.Msg || "操作失败！");
            that.$store.commit(this.$types.UPDATE_LOADING, false);
          }
        },
        canceledAction:  () => {
        }
      });
    },
    // noMoveVTM () {
    //   this.moveModelVTM = false;
    // }
  }
};
</script>

<style lang="less">
.businessList_pages {
 .ivu-row {
    /*padding: 0 10px;*/
    // background: red;
  }
  .ivu-col {
    text-align: left;
    font-size: 16PX;
    padding: 0 10px;
  }
  .row-head.ivu-row {
    background: #efefef;
  }
  .row-head .ivu-col {
    height: 0.7rem;
    line-height: 0.7rem;
  }
  .row-item .ivu-col {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 0.7rem;
    border-bottom: 0.5px solid #e9ebee;
    font-size: 14px;
  }
  .salesDept .ivu-select {
    height: 24px;
    line-height: 24px;
    /* width: 4.5rem; */
    width: 80%;
  }
  .salesDept .ivu-select-single .ivu-select-selection {
    height: 24px;
    line-height: 24px;
    border: none;
  }
  .salesDept .ivu-select-input {
    height: 24px;
    line-height: 24px;
    font-size: 16px;
    border: 1px solid #515a6e;
  }
  .ivu-select-single .ivu-select-input {
    width: 100% !important;
  }
  @media screen and (max-width: 1440px) {
    .ivu-col {
      font-size: 14px;
    }
    .row-item .ivu-col {
      font-size: 12px;
    }
    .salesDept .ivu-select-input {
      font-size: 12px;
    }
  }
}
</style>
<style lang="less" scoped>
@import "~@/styles/less/variable.less";

.businessList_pages {
  // width: 1250PX;
  // width: 100%;
  box-sizing:content-box;
  // flex: 0 !important;
  // height: 731PX;
  padding: 0 24px;
  // margin: 0.16rem   56px;
  background: #ffffff;
  border-radius: 5px;
}
.title {
  padding: 0 20px;
  border-bottom: 0.5px solid #e8e8e8;
  height: 60px;
}
.title h2 {
  // font-size: 16px;
  // line-height: 14px;
  font-weight: normal;
  padding: .24rem .16rem;
  position: relative;
  float: left;
  .fontsize-title-small();
}
.title h2:after {
  content: "";
  width: 3px;
  height: 20px;
  border-radius: 1px;
  background: #cfaa72;
  position: absolute;
  left: 0;
  top: .26rem;
}
.title h2:before {
  content: "";
  width: 3px;
  height: 14px;
  border-radius: 1px;
  background: #cfaa72;
  position: absolute;
  left: 6px;
  top: 0.32rem;
}
.search_input {
  float: right;
  height: 36px;
  border: 0.5px solid #e3e3e3;
  margin-top: 14px;
  width: 300px;
  border-radius: 3px;
  padding: 0 10px;
  display: flex;
  
}
.search_input input {
  border: none;
  outline: none;
  font-size: 14px;
  color: #999999;
  width: 250px;
}
.search_icon {
  width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.search_icon img {
  display: block;
  width: 16px;
  height: 16px;
}
.apptStatusRow {
  display: flex;
  font-size: 16px;
  height: 0.32rem;
  line-height: 0.32rem;
  padding: 0 0.3rem;
  align-items: center;
  margin: 0.2rem 0;
  width: 100%;
}
.apptStatusRow h3 {
  font-weight: normal;
  font-size: 16PX;
  margin-right: 20px;
  .fontsize-text-large();
}
.apptStatusRow ul {
  display: flex;
  flex: 1;
  .fontsize-text-large();
}
.apptStatusRow ul li {
  margin: 0 0.16rem;
  cursor: pointer;
}
.apptStatusRow ul li.on {
  color: #cfa972;
}
.apptStatusRow .btn {
  width: 1.1rem;
  height: 0.32rem;
  background: -webkit-linear-gradient(30deg, #e5c48a, #dcb36a);
  background: -moz-linear-gradient(30deg, #e5c48a, #dcb36a);
  background: -o-linear-gradient(30deg, #e5c48a, #dcb36a);
  background: linear-gradient(30deg, #e5c48a, #dcb36a);
  text-align: center;
  line-height: 0.32rem;
  font-size: 14px;
  color: #ffffff;
  border-radius: 5px;
  cursor: pointer;
  .fontsize-btn-medium();
}
.row-item {
  height: 0.7rem;
  font-size: 14px;
}
.row-item:nth-of-type(odd) {
  background: #fbfbfb;
}
.right {
  justify-content: flex-start;
}
.right a {
  font-size: 14px;
  /*margin-right: 10px;*/
  color: #cfaa72;
}
.right a:hover {
  text-decoration: underline;
}
.openModal {
  width: 7rem;
  position: fixed;
  z-index: 999;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  background: #ffffff;
  border-radius: 5px;
  padding: 0.2rem;
}
.mask {
  position: fixed;
  background: rgba(0, 0, 0, 0.4);
  z-index: 998;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.modal-header {
  // padding: 0 0.2rem;
  line-height: 20px;
  position: relative;
}
#steps {
  width: 10.8rem;
  min-width: 800Px;
}
.modal-header h3 {
  font-size: 16PX;
  font-weight: normal;
  color: #333333;
  .fontsize-title-small();
}
.modal-header .close {
  position: absolute;
  right: 0;
  font-size: 22px;
  color: #cccccc;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  top: 0;
  cursor: pointer;
}
.salesDept {
  display: flex;
  padding: 0.24rem 0 10px 10px;
  line-height: 24px;
  width: 6rem;
  margin: 0 10px;
}
.itembox {
  padding-top: 0;
  padding-bottom: 10px;
  flex-wrap: wrap;
  .item {
    width: 50%;
    display: flex;
    flex-direction: row;
    height: 0.4rem;
    margin-bottom: 10px;
    input {
      height: 0.4rem;
    }
  }
}
.salesDept span {
  font-size: 14px;
  margin-right: 0.1rem;
  line-height: 0.4rem;
  width: 1.3rem;
  color: #333333;
}
.salesDept label {
  min-width: 1rem;
}
.salesDept .ivu-select-visible .ivu-select-selection {
  box-shadow: none;
}
.jggtCheck span {
  padding-left: .65rem;
}
.modal-body h4 {
  font-size: 16px;
  color: #333333;
  padding: 25px 0;
  margin: 10px auto 0;
  text-align: center;
  font-weight: normal;
  border-top: .5px solid #e2e2e2;
}
.openAcctType_list {
  margin: 0 10px;
}
.openAcctType_list ul {
  display: flex;
}
.openAcctType_list li {
  width: 1.7rem;
  height: 1.8rem;
  border: 0.5px solid #e3e3e3;
  border-radius: 3px;
  margin: 0 0.2rem;
  cursor: pointer;
}
.openAcctType_list li .pic {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0.3rem 0 0.2rem 0;
}
.openAcctType_list li .pic img {
  width: 0.68rem;
  height: 0.68rem;
}
.openAcctType_list li span {
  font-size: 14px;
  display: block;
  text-align: center;
}
.openAcctType_list li.on {
  border-color: #cfa972;
}
.openAcctType_list li.on span {
  color: #cfa972;
}
.modal-footer {
  margin-top: 0.5rem;
}
.btns {
  display: flex;
  justify-content: flex-end;
  padding: 0 10px;
}
.btns .btn {
  width: 1rem;
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 14px;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
  margin-left: 0.32rem;
}
.btn.cancel {
  border: 0.5px solid #e3e3e3;
  color: #333333;
}
.btn.confirm {
  background: #dcb369;
  color: #ffffff;
}
.noMore {
  color: #999999;
  font-size: 16px;
  text-align: center;
  line-height: 100px;
}
.btn-download {
  width: 1.6rem;
  height: 0.32rem;
  text-align: center;
  line-height: 0.32rem;
  // font-size: 14px;
  border-radius: 5px;
  cursor: pointer;
  border: 0.5px solid #dcb36a;
  margin-right: 10px;
  color: #dcb36a;
  .fontsize-btn-medium();
}

.update_main {
  padding: 0;
  .fontsize-text-medium();
}
.update_main .item {
  display: flex;
  font-size: 14PX;
  padding-top: 0.24rem;
}
.update_main .item span {
  width: 2rem;
  text-align: right;
  margin-right: 10px;
  line-height: 0.42rem;
}
.update_main .tip {
  line-height: 0.16rem;
  padding: 0.13rem 0;
  display: flex;
  align-items: center;
  font-size: 14PX;
  color: #f06b6b;
}
.update_main .tip img {
  width: 0.18rem;
  height: 0.18rem;
  margin-right: 8px;
}
.update_main .input {
  border-bottom: 0.5px solid #e2e2e2;
  padding: 0 10px;
  line-height: 0.42rem;
  height: 0.42rem;
  display: flex;
}
.update_main input {
  border: 0;
  outline: none;
  width: 100%;
}
.update_main .tradeNo {
  line-height: 0.42rem;
  padding: 0 10px;
}
@media screen and (max-width: 1440px) {
  .businessList_pages {
    // height: 831px;
  }
  .title h2 {
    font-size: 14px;
  }
  .search_input input,
  .btn-download,
  .update_main .item {
    font-size: 12PX;
  }
  .apptStatusRow {
    font-size: 14px;
  }
  .apptStatusRow h3 {
    font-size: 14PX;
  }
  .apptStatusRow .btn {
    font-size: 12px;
    .fontsize-btn-medium();
  }
  .row-item {
    font-size: 12px;
  }
  .right a {
    font-size: 12px;
  }
  .modal-header h3 {
    // font-size: 14PX;
  }
  .salesDept span {
    font-size: 12px;
  }
  .modal-body h4 {
    font-size: 14px;
  }
  .openAcctType_list li span {
    font-size: 12px;
  }
  .btns .btn {
    font-size: 12px;
  }
}

.header {
  height: 0.6rem;
  border-radius: 0.05rem;
  background: #ffffff;
  margin: 0.3rem 0;
  display: flex;
  padding: 0 0.44rem;
  align-items: center;
}
.list_item {
  background: #ffffff;
  margin-bottom: 0.3rem;
  border-radius: 0.05rem;
}
.list_item .head {
  display: flex;
  align-items: center;
  height: 0.4rem;
  padding: 0 0.51rem;
}
.head .left {
  flex: 1;
  padding-left: 0.14rem;
  line-height: 0.15rem;
  position: relative;
  font-size: 0.12rem;
}
.head .left:after {
  content: "";
  width: 0.03rem;
  top: 0;
  bottom: 0;
  background: #cfaa72;
  border-radius: 0.01rem;
  position: absolute;
  left: 0;
}

.body {
  padding: 0.13rem 0.65rem;
  background: #f8f8f8;
  font-size: 0.14rem;
  line-height: 0.48rem;
}
.inputSearch {
  flex: 1;
  padding: 0 30px;
}
.cancellation {
  display: flex;
  align-items: center;
  justify-content: center;
}
#steps .modal-body .update_main {
  padding: 10px 0;
}
.warnImg {
  margin-top: -0.32rem;
}

/deep/.self-selector .el-form-item__content .select{
  width: 150% !important;
}
</style>


// WEBPACK FOOTER //
// src/oldCode/pages/businessList.vue